import { useState, useEffect } from "react";
import { Menu, X, LogOut } from "lucide-react";
import { Link } from "react-router-dom";
import { motion, useAnimation } from "framer-motion";
import { Outlet } from "react-router-dom";
import DashboardHeader from "./components/dashboardHeader/DashboardHeader";
import { sideBarLinks } from "./components/links";
import logo from '../../assets/images/logo.webp'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../../../components/ui/tooltip"

export default function DashboardSidebar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const controls = useAnimation();

  // Handle sidebar toggle
  const toggleSidebar = () => {
    if (!isMobile) {
      setIsOpen(!isOpen);
    }
  };



  // Handle responsive behavior
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);

      if (mobile) {
        // On mobile, sidebar is fixed at the bottom and only shows icons
        controls.start({ width: "100%", height: "4rem", bottom: 0, top: "auto" });
      } else {
        // On desktop, sidebar behaves as before
        controls.start({ width: isOpen ? "14rem" : "4rem", height: "100%", top: 0, bottom: "auto" });
      }
    };

    handleResize(); // Initial call
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isOpen, controls, isMobile]);





  function NavigationLinks() {
   
    const [selected,setSelected] = useState(false)

    


    return (

      <nav className={`flex  ${isMobile ? "flex-row justify-around items-center" : "flex-col space-y-2  pt-10 "} p-2 ${isMobile ? "h-full" : "mt-4"}`}>
        {
          sideBarLinks?.map(({ label, to, icon,tag ,target}, key) => <Tooltip key={key} >
            <TooltipTrigger  >
              <SidebarItem to={to} target={target} icon={icon} label={label} isOpen={isOpen} isMobile={isMobile} selected={window.location.pathname == to} setSelected={setSelected}/>
            </TooltipTrigger>
            {!isOpen &&
              <TooltipContent>
                <p className="text-neutral-400">{label}</p>
              </TooltipContent>
            }
          </Tooltip>)
        }


      </nav>

    )


  }








  return (
    <div className="flex ">
      {/* Sidebar */}
      <motion.div
        className={`fixed z-50 bg-neutral-900 text-white shadow-lg flex flex-col overflow-hidden overflow-x-scroll  border-yellow-500/5 ${!isMobile && "pt-10 border-r"}`}
        initial={{ width: "4rem", height: "100%", top: 0 }}
        animate={controls}
        transition={{ type: "spring", stiffness: 200, damping: 25 }}
      >
        {isOpen &&!isMobile &&
        
        <div className="absolute top-5 left-4 flex items-center gap-2">
          <img src={logo} className="w-8 h-8" alt="" />
        <p className="font-logo text-2xl text-center text-orange-500 animate-pulse">
          Phoenix</p>
        </div>
          }
        {/* Toggle Button (Desktop Only) */}
        {!isMobile && (
          <motion.button
            className="fixed top-4 left-1 p-2 bg-neutral-800 text-white rounded-md shadow-lg z-50"
            onClick={toggleSidebar}
            initial={{ x: 0 }}
            animate={{ x: isOpen ? "12rem" : "0.5rem" }} // Adjusted to prevent overlap
            transition={{ type: "spring", stiffness: 200, damping: 25 }}
          >
            {isOpen ? <X size={24} className="text-orange-800 hover:text-orange-500" /> : <Menu size={24} className="text-orange-800 hover:text-orange-500" />}
          </motion.button>
        )}

        {/* Navigation */}
        <div className={`flex flex-col justify-between h-full  ${isMobile && " w-screen overflow-x-scroll"}`}>
          <TooltipProvider >
            <NavigationLinks />
          </TooltipProvider>

         {!isMobile && <div className={`flex ${isMobile ? "flex-row justify-around items-center " : "flex-col space-y-2"} p-2 ${isMobile ? "h-full" : "mt-4"}`}>
            <SidebarItem to="/" icon={<LogOut size={24} />} label="Exit to Main" isOpen={isOpen} isMobile={isMobile} />
          </div>}
        </div>
      </motion.div>

      {/* Main Content */}
      <motion.div
        className="flex-grow"
        initial={{ marginLeft: "4rem" }}
        animate={{
          marginLeft: isMobile ? "0" : isOpen ? "14rem" : "4rem",
        }}
        transition={{ type: "spring", stiffness: 200, damping: 25 }}
      >
        <div className="container pt-5">

        <DashboardHeader />
        </div>
        <Outlet />
      </motion.div>
    </div>
  );
}






// Sidebar Item Component
function SidebarItem({ to, icon, label, isOpen, isMobile, selected , setSelected , target }) {

  return (
    <Link
      to={to}
      target={target || "_self"}
      onClick={()=>setSelected(label)}
      className={`flex items-center gap-3  rounded-md group transition-all duration-500 ${!selected && 'hover:bg-orange-500/10'} hover:text-white  transition-all duration-200 ${isMobile ? " flex-col p-3 bg-yellow-500/5" : "h-10 flex-row p-3"} ${selected && "!bg-orange-500/70  text-black"}`}
    >
      <div  className={`w-10 flex justify-center items-center  transition-all   duration-500 ${selected ? "text-black group-hover:text-black" : 'text-orange-500/30 group-hover:text-orange-600 group-hover:animate-pulse duration-900 '}`}>{icon}</div>
      {!isMobile && (
        <motion.span
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: isOpen ? 1 : 0, x: isOpen ? 0 : -10 , }}
          transition={{ duration: 0.5 , delay:0.25}}
        >
          {label}
        </motion.span>
      )}
    </Link>
  );
}